import { render, staticRenderFns } from "./NewsDetailItem1.vue?vue&type=template&id=18788384"
import script from "./NewsDetailItem1.vue?vue&type=script&lang=ts"
export * from "./NewsDetailItem1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports